// Invoice line quantity for people to read. Billing keeps hours as units (1 h = 1 unit, 30 min = 0.5 unit);
// the screen shows the time in minutes with the units in brackets, e.g. "31 min (0.51 units)".

// Lines charged per night / per item, not per hour: minutes mean nothing there.
const PER_UNIT_KINDS = new Set(['sleepover_flat', 'sleepover_bundled', 'transport_segment']);

const unitsLabel = (n) => {
  const v = Math.round(n * 100) / 100;
  return `${v} ${v === 1 ? 'unit' : 'units'}`;
};

export function formatDuration(hours) {
  const total = Math.round((Number(hours) || 0) * 60);
  const h = Math.floor(total / 60);
  const m = total % 60;
  if (h === 0) return `${m} min`;
  return m === 0 ? `${h} h` : `${h} h ${m} min`;
}

export function formatInvoiceQuantity(line) {
  // BS3-007 / BS3-008: per-night and per-km lines carry their own quantity and unit
  const unit = String(line?.unit || '').toLowerCase();
  if (unit === 'night') {
    const q = Number(line.quantity ?? 1);
    return `${q} ${q === 1 ? 'night' : 'nights'}`;
  }
  if (unit === 'km') return `${Math.round(Number(line.quantity ?? line.distance_km ?? 0) * 100) / 100} km`;
  const hours = line?.hours ?? line?.quantity;
  if (hours === null || hours === undefined || hours === '' || Number.isNaN(Number(hours))) return '—';
  const n = Number(hours);
  if (PER_UNIT_KINDS.has(line?.kind)) return unitsLabel(n);
  return `${formatDuration(n)} (${unitsLabel(n)})`;
}
